import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import {
  GET_COLLECTION,
  CREATE_COLLECTION_NEW_RECORD
} from "../actions";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";

import {
  getCollectionSuccess,
  getCollectionError,
  createCollectionNewRecordSuccess,
  createCollectionNewRecordError,  
} from "./actions";

const CREATE_NEW_RECORD_ERROR = "New record success.";

export function* watchGetCollection() {
  yield takeEvery(GET_COLLECTION, getCollection);
}

const createCollectionNewRecordAsync = async (newRecord) => {

  try{
    if (newRecord.collection_id > 0)
    {
      const responseObject = await centralApiAxios.put("collections/"+ newRecord.collection_id, newRecord);

      return {
      newsItem: responseObject.data,
      vocabulary_id: responseObject.data.collection_id,
      trashed : newRecord.trashed,
      isNewsItemCreate: !(newRecord.vocabulary_id > 0),
      message: ""
      };
    }
    else{
      const responseObject = await centralApiAxios.post("collections?id="+ newRecord.collection_id, newRecord);

      return {
      newsItem: responseObject.data,
      vocabulary_id: responseObject.data.collection_id,
      trashed : newRecord.trashed,
      isNewsItemCreate: !(newRecord.vocabulary_id > 0),
      message: ""
      };
    }

  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* createCollectionNewRecord({ payload }) {
     const { history } = payload;
    try {
      const resultReturned = yield call(createCollectionNewRecordAsync, payload.newRecord);
      if (!resultReturned.message) {
        yield put(createCollectionNewRecordSuccess(resultReturned));
        if (payload.newRecord.trashed == true) {
          history.push("/app/RecordListing/Collection");
          window.location.reload();
        }
        else{
          window.location.reload();
        }
      } else {
        yield put(createCollectionNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(createCollectionNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}

const getCollectionAsync = async (payload) => {
  try {
    const recordCollectionListReturned = await centralApiAxios.get("collections/"+payload.collectionId, getActivityHeadersUpdated(payload));

    if (recordCollectionListReturned.data) {
      return {
        collection: recordCollectionListReturned.data,
        message: null,
      };
    }
    return { message: "Get collection failed." };
  } catch (error) {
    return {
      message: "Failed to get collection. ",
    };
  }
};

function* getCollection({ payload }) {
  try {
    const returnedData = yield call(getCollectionAsync, payload);
    if (!returnedData.message) {
      yield put(
        getCollectionSuccess({
          collection: returnedData.collection,
        })
      );
    } else {
      yield put(getCollectionError(returnedData.message));
    }
  } catch (error) {
    yield put(getCollectionError(error));
  }
}
 // eslint-disable-next-line
export function* watchCreateRecords(newRecord) {
  yield takeEvery(CREATE_COLLECTION_NEW_RECORD, createCollectionNewRecord);
}


export default function* rootSaga() {
  yield all([
    fork(watchGetCollection),
    fork(watchCreateRecords)
  ]);
}
